import React from "react";
import { PupsFundDogModel } from "../types/pupsFundDogModel";

interface PupsFundDogCardProps {
  dog: PupsFundDogModel;
}

const PupsFundDogCard: React.FC<PupsFundDogCardProps> = ({ dog }) => {
  // Ensure the image URL is complete
  const getImageUrl = (imageUrl: string) => {
    if (imageUrl && !imageUrl.startsWith("http")) {
      // If it's a relative path, prepend the API URL
      return `${process.env.REACT_APP_API_URL}${imageUrl}`;
    }
    return imageUrl;
  };

  return (
    <div className="flex w-[200px] flex-col overflow-hidden rounded-2xl border-2 border-gray-200 bg-white shadow-md">
      <div className="relative h-[200px] w-[200px] overflow-hidden">
        <img
          src={getImageUrl(dog.image)}
          alt={`${dog.name}`}
          className="h-full w-full object-cover"
          onError={(e) => {
            // Fallback for broken images
            e.currentTarget.src =
              "https://via.placeholder.com/350x250?text=No+Image";
          }}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-blue bg-opacity-60 p-2">
          <h3 className="text-center text-lg font-bold capitalize text-white">
            {dog.name}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default PupsFundDogCard;
